module.exports = __webpack_public_path__ + "img/doublecheck.9ae396e1.svg";